import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import { Box, Divider, Grid, IconButton, Typography } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import { PhotoCamera } from '@mui/icons-material'
import { imgs, onImgError } from 'constants/images'
import useStyles from 'features/setting/personnel-managements/personnels/style'
import * as UseStyled from 'features/setting/personnel-managements/personnels/useStyles'

/** API */
import { fileUrl } from 'api/api'
import PersonnelApi, { ChangePassword } from 'api/setting/personnel-managements/personnel.api'
import { routeName } from 'routes/routes-name'

/** UTILS || SLICE */
import { resetModal } from 'app/slice/modal.slice'
import { editMe, editUser, loadUserFormDocument, loadUserFormEduction, loadUserFormInfo, loadUserFormSalary, loadUserFormSchedule, loadUserFormSetup, loadUserProfile, selectMe, selectUser } from 'app/slice/user.slice'
import { getPackageKey } from 'utils/app.utils'

/** CONSTANT */
import { userLimit } from 'constants/package'
import { colors } from 'constants/theme'

/** COMPONENT */
import BtnEditOutlined from 'assets/button/BtnEditOutlined'
import { swalWarning } from 'component/Alert/Swal'
import HeaderLabel from 'component/CardCustom/HeaderLabel'
import Loading from 'component/Loading'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import Document from 'features/setting/personnel-managements/personnels/form-personnel-document'
import Education from 'features/setting/personnel-managements/personnels/form-personnel-education'
import Information from 'features/setting/personnel-managements/personnels/form-personnel-info'
import SalarynPosition from 'features/setting/personnel-managements/personnels/form-personnel-salary'
import Schedule from 'features/setting/personnel-managements/personnels/form-personnel-schedule'
import SetupAccount from 'features/setting/personnel-managements/personnels/form-personnel-setup'
import { checkIsUltraPackage, checkUserLimit } from 'features/setting/personnel-managements/personnels/personnels'
import TextInput from 'new-components/inputs/text-input'
import PageModal from 'new-components/modal/page-modal'

import CloseIcon from '@mui/icons-material/Close'
import PersonIcon from '@mui/icons-material/Person'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import Webcam from 'react-webcam'

const initStateErrorMessage = {
  USER_CODE: '',
  USER_NAME: '',
  PASSWORD: '',
  CONFIRM_PASSWORD: '',
  PREFIX: '',
  FIRST_NAME: '',
  LAST_NAME: '',
  LAST_NAME_EN: '',
  FIRST_NAME_EN: '',
  POSITION: '',
  CERTIFICATE: '',
  ROLE: '',
  PASSWORD_NOT_MATCH: '',
  MINIMUM_PASSWORD: ''
}

export const initStatePasswordErrorMessage = {
  NEW_PASSWORD: '',
  CONFIRM_PASSWORD: '',
  PASSWORD_NOT_MATCH: '',
  MINIMUM_PASSWORD: ''
}

const initStateValue = {
  userCode: '',
  username: '',
  password: '',
  confirmPassword: '',
  prefix: '',
  firstname: '',
  lastname: '',
  firstnameEn: '',
  lastnameEn: '',
  displayName: '',
  email: '',
  idCard: '',
  dateOfBirth: '',
  phone: '',
  telephone: '',
  facebook: '',
  line: '',
  address: '',
  countryId: 0,
  provinceId: 0,
  districtId: 0,
  subDistrictId: 0,
  postcode: '',
  positionId: 0,
  roleId: 0,
  certificate: '',
  salary: 0,
  creditCardFee: 0,
  creditCardFeeType: 'PERCENT',
  expertId: 0,
  bankId: 0,
  bankAccountNumber: '',
  bankAccountName: '',
  isInsure: '0',
  isAdmin: '0',
  ownAppointment: '0',
  ownSchedule: '0',
  ownDocument: '0',
  isViewDfAndLab: '0',
  isViewDfConfirm: '0',
  autoShowPatientProfile: '0',
  hasCancelBill: 'UNPERMISS',
  hasResetBill: 'UNPERMISS',
  hasChangeTreatmentCost: 'UNPERMISS',
  manageTreatmentCostType: 'DEFAULT',
  hasChangeTreatmentNote: 'UNPERMISS',
  hasChangePrice: 'UNPERMISS',
  hasChangeDiscountAdditional: 'UNPERMISS',
  hasManageAdvances: 'UNPERMISS',
  hasUnfollow: 'UNPERMISS',
  hasDiagnosis: 'UNPERMISS',
  hasCreateDiagnosis: 'UNPERMISS',
  hasDeleteDiagnosis: 'UNPERMISS',
  hasMed: 'UNPERMISS',
  hasCreateMed: 'UNPERMISS',
  hasDeleteMed: 'UNPERMISS',
  hasProduct: 'UNPERMISS',
  hasCreateProduct: 'UNPERMISS',
  hasDeleteProduct: 'UNPERMISS',
  hasTreatment: 'UNPERMISS',
  hasCreateTreatment: 'UNPERMISS',
  hasInsuranceCost: 'UNPERMISS',
  hasDeleteTreatment: 'UNPERMISS',
  hasTreatmentPlan: 'UNPERMISS',
  hasCreateTreatmentPlan: 'UNPERMISS',
  hasDeleteTreatmentPlan: 'UNPERMISS',
  hasTreatmentCourse: 'UNPERMISS',
  hasEditCourse: 'UNPERMISS',
  hasCreateTreatmentCourse: 'UNPERMISS',
  hasDeleteTreatmentCourse: 'UNPERMISS',
  hasDoctorNote: 'UNPERMISS',
  hasCancelTreatmentQueue: 'UNPERMISS',
  hasEditBill: 'UNPERMISS',
  hasCreateDoctorNote: 'UNPERMISS',
  hasDeleteDoctorNote: 'UNPERMISS',
  hasCancelVisit: 'UNPERMISS',
  hasCancelLabOrder: 'UNPERMISS',
  hasReplyLabOrder: 'UNPERMISS',
  hasViewIncome: 'UNPERMISS',
  hasShowPhoneNumber: 'UNPERMISS',
  hasApproveIncomeAndExpenses: 'UNPERMISS',
  hasApproveTheAmountChange: 'UNPERMISS',
  hasOverdueRequest: 'UNPERMISS',
  userWorkplaces: [],
  userBackgrounds: [],
  userAttachments: [],
  profile: {
    fileId: 0,
    base64: '',
    type: '',
    fileExtension: '',
    fileSize: ''
  },
  signatureAttachments: {
    fileId: 0,
    base64: '',
    fileExtension: '',
    fileSize: ''
  },
  status: 'ACTIVE'
}

type TemplatePassword = {
  newPassword: string
  confirmPassword: string
}

type PersonnelType = {
  userCode: string
  username: string
}

export type InitStatePasswordErrorMessageType = {
  NEW_PASSWORD: string
  CONFIRM_PASSWORD: string
  PASSWORD_NOT_MATCH: string
  MINIMUM_PASSWORD: string
}

type InitStateErrorMessageType = {
  USER_CODE: string
  USER_NAME: string
  PASSWORD: string
  CONFIRM_PASSWORD: string
  PREFIX: string
  FIRST_NAME: string
  LAST_NAME: string
  FIRST_NAME_EN: string
  LAST_NAME_EN: string
  POSITION: string
  CERTIFICATE: string
  ROLE: string
  PASSWORD_NOT_MATCH: string
  MINIMUM_PASSWORD: string
}

enum TABS_FORM_TYPE {
  SETUP = 'SETUP',
  INFO = 'INFO',
  SALARY = 'SALARY',
  EDUCATION = 'EDUCATION',
  SCHEDULE = 'SCHEDULE',
  DOCUMENT = 'DOCUMENT'
}

export default function FormPersonnel() {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const classes = useStyles()
  const user = useSelector(selectMe)

  const webcamRef: any = useRef(null)

  const [tab, setTab] = useState<TABS_FORM_TYPE>(TABS_FORM_TYPE.SETUP)
  const userSetup = useSelector(selectUser)

  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [tabForm, setTabForm] = useState<TABS_FORM_TYPE>(TABS_FORM_TYPE.SETUP)
  const [loading, setLoading] = useState(false)
  const [status, setStatus] = useState<'ACTIVE' | 'INACTIVE'>('ACTIVE')
  const [oldStatus, setOldStatus] = useState<'ACTIVE' | 'INACTIVE'>('ACTIVE')

  const [readOnly, setReadOnly] = useState(true)
  const templatePassword: TemplatePassword = { newPassword: '', confirmPassword: '' }
  const [password, setPassword] = useState<TemplatePassword>(templatePassword)

  const [errorMessage, setErrorMessage] = useState<InitStateErrorMessageType>(initStateErrorMessage)
  const [passwordErrorMessage, setPasswordErrorMessage] = useState<InitStatePasswordErrorMessageType>(initStatePasswordErrorMessage)

  const [userId, setUserId] = useState(Number)
  const [profileData, setProfileData] = useState<any | null>()
  const [profile, setProfile] = useState<any | null>()
  const [personnel, setPersonnel] = useState<PersonnelType>({ userCode: '', username: '' })
  const [attachments, setAttachments] = useState([])


  const [isOpen, setIsOpen] = useState(false)
  const [isOpenPic, setIsOpenPic] = useState(false)
  const [statusEdit, setStatusEdit] = useState<'username' | 'password'>('username')
  const [inputModal, setInputModal] = useState('')
  const [errMessageModal, setErrorMessageModal] = useState('')
  const [imageModal, setImageModal] = useState<any | null>()
  const [isOpenWebCam, setIsOpenWebCam] = useState(false)

  const fileInputRef = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    if (!isOpenPic) {
      setImageModal(null)
      setIsOpenWebCam(false)
    }
  }, [isOpenPic])

  const MAX_FILE_SIZE = 2 * 1024 * 1024
  const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
    accept: 'image/*',
    maxSize: MAX_FILE_SIZE,
    multiple: false,
    onDropRejected: (fileRejections) => {
      const names = fileRejections.map(r => r.file.name).join(', ')
      notiError(`ไฟล์ (${names}) ขนาดเกิน 2MB หรือชนิดไฟล์ไม่รองรับ`)
    },
    onDropAccepted: (acceptedFiles) => {
      uploadProfile(acceptedFiles)
    }
  })


  useEffect(() => {
    if (location.state) {
      reduxEdit(location.state)
    } else {
      create()
      if (!checkIsUltraPackage()) {
        const packageUserLimit = async () => {
          await checkUserLimit(
            t('PERSONNEL.MESSAGE.LIMIT_PACKAGE.TITLE'),
            t('PERSONNEL.MESSAGE.LIMIT_PACKAGE.SUBTITLE', {
              package: getPackageKey(),
              number: userLimit(getPackageKey())
            }),
            () => {
              history.push(routeName.personnels)
            },
            () => {
              return
            }
          )
        }
        packageUserLimit()
      }
    }
  }, [location, dispatch])

  useEffect(() => {
    const password = userSetup.setup.password
    const username = userSetup.setup.username

    /**
     * a. ความยาวอย่างน้อย 8 หลัก
     * b. ประกอบด้วยตัวอักษร และ ตัวเลข
     * c. ถ้าเป็นอักษรภาษาอังกฤษ ต้องมีอักษรตัวใหญ่และเล็กผสมกัน
     * d. ไม่สามารถใช้รหัสผ่านเป็นภาษาไทยได้
     * e. ต้องไม่มีชื่อผู้ใช้งานเป็นส่วนหนึ่งส่วนใดของรหัสผ่าน
     */
    if (password) {
      const newTab: TABS_FORM_TYPE = TABS_FORM_TYPE.SETUP
      setTab(newTab)
      setTabForm(newTab)

      const tempMessage = t('PERSONNEL.MESSAGE.LIMIT_PACKAGE.MESSAGE_PASSWORD')
      let message = ''
      /** ความยาวอย่างน้อย 8 หลัก */
      if (password.length < 8) message = tempMessage
      /** ประกอบด้วยตัวอักษมีอักษรตัวใหญ่และเล็กผสมกัน และ ตัวเลข */ else if (password.toLowerCase() === password) message = tempMessage
      else if (password.toUpperCase() === password) message = tempMessage
      else if (!/\d/.test(password)) message = tempMessage
      else if (/[ก-๙]/.test(password)) message = tempMessage
      /**  e. ต้องไม่มีชื่อผู้ใช้งานเป็นส่วนหนึ่งส่วนใดของรหัสผ่าน */ else if (username && password && password.search(username) !== -1) message = tempMessage

      return setErrorMessage({
        ...errorMessage,
        PASSWORD: message
      })
    }
  }, [userSetup.setup.username, userSetup.setup.password])

  const create = () => {
    const {
      userCode,
      username,
      password,
      confirmPassword,
      prefix,
      firstname,
      lastname,
      firstnameEn,
      lastnameEn,
      displayName,
      email,
      idCard,
      dateOfBirth,
      phone,
      telephone,
      facebook,
      line,
      address,
      countryId,
      provinceId,
      districtId,
      subDistrictId,
      postcode,
      positionId,
      roleId,
      certificate,
      salary,
      creditCardFee,
      creditCardFeeType,
      expertId,
      bankId,
      bankAccountNumber,
      bankAccountName,
      isInsure,
      isAdmin,
      ownAppointment,
      ownSchedule,
      ownDocument,
      isViewDfAndLab,
      isViewDfConfirm,
      autoShowPatientProfile,
      hasCancelBill,
      hasResetBill,
      hasCancelTreatmentQueue,
      hasCancelVisit,
      hasCancelLabOrder,
      hasReplyLabOrder,
      hasViewIncome,
      hasChangeTreatmentCost,
      manageTreatmentCostType,
      hasChangeTreatmentNote,
      hasChangePrice,
      hasChangeDiscountAdditional,
      hasManageAdvances,
      hasUnfollow,
      hasDiagnosis,
      hasCreateDiagnosis,
      hasDeleteDiagnosis,
      hasMed,
      hasCreateMed,
      hasDeleteMed,
      hasProduct,
      hasCreateProduct,
      hasDeleteProduct,
      hasTreatment,
      hasCreateTreatment,
      hasDeleteTreatment,
      hasTreatmentPlan,
      hasCreateTreatmentPlan,
      hasDeleteTreatmentPlan,
      hasTreatmentCourse,
      hasEditCourse,
      hasCreateTreatmentCourse,
      hasDeleteTreatmentCourse,
      hasDoctorNote,
      hasEditBill,
      hasCreateDoctorNote,
      hasDeleteDoctorNote,
      userBackgrounds,
      userWorkplaces,
      hasInsuranceCost,
      userAttachments,
      signatureAttachments,
      profile,
      hasShowPhoneNumber,
      hasApproveIncomeAndExpenses,
      hasApproveTheAmountChange,
      hasOverdueRequest
    } = initStateValue

    dispatch(
      loadUserFormSetup({
        userCode,
        username,
        ownAppointment,
        ownSchedule,
        ownDocument,
        isViewDfAndLab,
        isViewDfConfirm,
        autoShowPatientProfile,
        hasCancelBill,
        hasResetBill,
        hasCancelVisit,
        hasCancelLabOrder,
        hasReplyLabOrder,
        hasViewIncome,
        hasChangeTreatmentCost,
        manageTreatmentCostType,
        hasChangeTreatmentNote,
        hasChangePrice,
        hasChangeDiscountAdditional,
        hasManageAdvances,
        hasUnfollow,
        hasDiagnosis,
        hasCreateDiagnosis,
        hasDeleteDiagnosis,
        hasMed,
        hasCreateMed,
        hasDeleteMed,
        hasProduct,
        hasCreateProduct,
        hasDeleteProduct,
        hasTreatment,
        hasCreateTreatment,
        hasDeleteTreatment,
        hasTreatmentPlan,
        hasCreateTreatmentPlan,
        hasDeleteTreatmentPlan,
        hasTreatmentCourse,
        hasEditCourse,
        hasCreateTreatmentCourse,
        hasDeleteTreatmentCourse,
        hasDoctorNote,
        hasCreateDoctorNote,
        hasDeleteDoctorNote,
        password,
        confirmPassword,
        hasCancelTreatmentQueue,
        hasEditBill,
        hasInsuranceCost,
        hasShowPhoneNumber,
        hasApproveIncomeAndExpenses,
        hasApproveTheAmountChange,
        hasOverdueRequest
      })
    )
    dispatch(loadUserFormInfo({ prefix, firstname, lastname, firstnameEn, lastnameEn, displayName, email, idCard, dateOfBirth, phone, telephone, facebook, line, address, countryId, provinceId, districtId, subDistrictId, postcode }))
    dispatch(loadUserFormEduction({ userBackgrounds: [...userBackgrounds] }))
    dispatch(loadUserFormSalary({ positionId, roleId, certificate, salary, creditCardFee, creditCardFeeType, expertId, bankId, bankAccountNumber, bankAccountName, isInsure, isAdmin }))
    dispatch(loadUserFormSchedule({ userWorkplaces: [...userWorkplaces] }))
    dispatch(loadUserFormDocument({ userAttachments: [...userAttachments], signatureAttachments: signatureAttachments }))
    dispatch(loadUserProfile(profile))
    setIsEdit(false)
  }

  const reduxEdit = (locationState: any) => {
    setUserId(Number(locationState.userId))
    const {
      userCode,
      username,
      prefix,
      firstname,
      lastname,
      firstnameEn,
      lastnameEn,
      displayName,
      email,
      idCard,
      dateOfBirth,
      phone,
      telephone,
      facebook,
      line,
      address,
      countryId,
      provinceId,
      districtId,
      subDistrictId,
      postcode,
      positionId,
      roleId,
      certificate,
      salary,
      creditCardFee,
      creditCardFeeType,
      expertId,
      bankId,
      bankAccountNumber,
      bankAccountName,
      isInsure,
      isAdmin,
      ownAppointment,
      isViewDfAndLab,
      isViewDfConfirm,
      autoShowPatientProfile,
      ownSchedule,
      ownDocument,
      hasCancelBill,
      hasResetBill,
      hasCancelTreatmentQueue,
      hasCancelVisit,
      hasCancelLabOrder,
      hasReplyLabOrder,
      hasViewIncome,
      hasChangeTreatmentCost,
      manageTreatmentCostType,
      hasChangeTreatmentNote,
      hasChangePrice,
      hasChangeDiscountAdditional,
      hasManageAdvances,
      hasUnfollow,
      hasDiagnosis,
      hasMed,
      hasCreateMed,
      hasDeleteMed,
      hasProduct,
      hasCreateProduct,
      hasDeleteProduct,
      hasCreateDiagnosis,
      hasDeleteDiagnosis,
      hasTreatment,
      hasCreateTreatment,
      hasDeleteTreatment,
      hasTreatmentPlan,
      hasCreateTreatmentPlan,
      hasDeleteTreatmentPlan,
      hasTreatmentCourse,
      hasEditCourse,
      hasCreateTreatmentCourse,
      hasDeleteTreatmentCourse,
      hasDoctorNote,
      hasEditBill,
      hasCreateDoctorNote,
      hasDeleteDoctorNote,
      userBackgrounds,
      userWorkplaces,
      userAttachments,
      signature,
      status,
      profile,
      hasInsuranceCost,
      hasShowPhoneNumber,
      hasApproveIncomeAndExpenses,
      hasApproveTheAmountChange,
      hasOverdueRequest,
      userTags
    } = locationState
    setStatus(status)
    setOldStatus(status)
    setAttachments(userAttachments)

    if (profile?.fileName) {
      const { fileName, filePath } = profile
      const path: any = `${fileUrl}/${filePath}/${fileName}`
      setProfileData(path)
      setImageModal(path)
    }
    const userBackground = userBackgrounds.map((obj: any) => {
      delete obj.userId
      delete obj.userBackgroundId
      return obj
    })

    const userWorkplace = userWorkplaces.map((obj: any) => {
      delete obj.userId
      delete obj.userWorkplaceId
      return obj
    })

    const userAttachment = userAttachments.map((obj: any) => {
      if (!obj.file) {
        return { attachmentType: obj.attachmentType, userAttachmentId: obj.userAttachmentId, fileId: 0, base64: '', type: '', fileSize: '', fileExtension: '' }
      }
      return { attachmentType: obj.attachmentType, userAttachmentId: obj.userAttachmentId, fileId: obj.file.fileId, base64: '', type: obj.file.fileName, fileSize: '', fileExtension: '' }
    })

    let urlS: any = ''
    let sig = { fileId: 1, base64: '', type: 'fileName', fileExtension: '', fileSize: '', filePath: '' }
    const pro = { fileId: 1, base64: '', type: 'profile.fileName', fileExtension: '', fileSize: '' }

    if (signature) {
      const timeNow = moment().format('HHmmss')
      const { filePath: sFilePath, fileName: sFileName } = signature
      urlS = `${fileUrl}/${sFilePath}/${sFileName}`
      sig = { fileId: signature.fileId, base64: '', type: '', fileExtension: '', fileSize: '', filePath: urlS }
    }

    dispatch(
      loadUserFormSetup({
        userCode,
        username,
        ownAppointment,
        ownSchedule,
        ownDocument,
        isViewDfAndLab,
        isViewDfConfirm,
        autoShowPatientProfile,
        hasCancelBill,
        hasCancelVisit,
        hasCancelLabOrder,
        hasReplyLabOrder,
        hasViewIncome,
        hasChangeTreatmentCost,
        manageTreatmentCostType,
        hasChangeTreatmentNote,
        hasChangePrice,
        hasChangeDiscountAdditional,
        hasManageAdvances,
        hasUnfollow,
        hasDiagnosis,
        hasCreateDiagnosis,
        hasDeleteDiagnosis,
        hasMed,
        hasCreateMed,
        hasDeleteMed,
        hasProduct,
        hasCreateProduct,
        hasDeleteProduct,
        hasTreatment,
        hasTreatmentPlan,
        hasTreatmentCourse,
        hasEditCourse,
        hasDoctorNote,
        status,
        hasResetBill,
        hasCreateTreatment,
        hasDeleteTreatment,
        hasCreateTreatmentPlan,
        hasDeleteTreatmentPlan,
        hasCreateTreatmentCourse,
        hasDeleteTreatmentCourse,
        hasCreateDoctorNote,
        hasDeleteDoctorNote,
        hasEditBill,
        hasCancelTreatmentQueue,
        hasInsuranceCost,
        hasShowPhoneNumber,
        hasApproveIncomeAndExpenses,
        hasApproveTheAmountChange,
        hasOverdueRequest
      })
    )
    dispatch(loadUserFormInfo({ prefix, firstname, lastname, firstnameEn, lastnameEn, displayName, email, idCard, dateOfBirth, phone, telephone, facebook, line, address, countryId, provinceId, districtId, subDistrictId, postcode }))
    dispatch(loadUserFormEduction({ userBackgrounds: [...userBackground] }))
    dispatch(loadUserFormSalary({ positionId, roleId, certificate, salary, creditCardFee, creditCardFeeType, expertId, bankId, bankAccountNumber, bankAccountName, isInsure, isAdmin, userTags }))
    dispatch(loadUserFormSchedule({ userWorkplaces: [...userWorkplace] }))
    dispatch(loadUserFormDocument({ userAttachments: [...userAttachment], signatureAttachments: sig }))
    dispatch(loadUserProfile(pro))
    setIsEdit(true)
    setPersonnel({ userCode: userCode, username: username })
  }

  const submit = async () => {
    const { setup, info, salary, education, schedule, document } = userSetup
    const objCreate = {
      ...setup,
      ...info,
      ...salary,
      ...education,
      ...schedule,
      ...document,
      profile
    }

    if (objCreate?.userTags?.length) {
      objCreate['userTags'] = objCreate?.userTags?.map((item: any) => { return { tagId: item.tagId } })
    }

    if (
      !objCreate.userCode ||
      !objCreate.username ||
      !objCreate.password ||
      !objCreate.confirmPassword ||
      !objCreate.prefix ||
      !objCreate.firstname ||
      !objCreate.lastname ||
      !objCreate.firstnameEn ||
      !objCreate.lastnameEn ||
      !objCreate.positionId ||
      (Number(objCreate.positionId) === 2 && !objCreate.certificate) ||
      !objCreate.roleId
    ) {
      let newTab: TABS_FORM_TYPE = tab
      if (!objCreate.userCode || !objCreate.username || !objCreate.password || !objCreate.confirmPassword) newTab = TABS_FORM_TYPE.SETUP
      else if (!objCreate.prefix || !objCreate.firstname || !objCreate.lastname || !objCreate.firstnameEn || !objCreate.lastnameEn) newTab = TABS_FORM_TYPE.INFO
      else if (!objCreate.positionId || !objCreate.roleId || (Number(objCreate.positionId) === 2 && !objCreate.certificate)) newTab = TABS_FORM_TYPE.SALARY
      setTab(newTab)
      setTabForm(newTab)
      return setErrorMessage({
        ...errorMessage,
        USER_CODE: !objCreate.userCode ? t('VALIDATION.USER_CODE') : '',
        USER_NAME: !objCreate.username ? t('VALIDATION.USER_NAME') : '',
        PASSWORD: !objCreate.password ? t('LOGIN.MESSAGE.PASSWORD') : '',
        CONFIRM_PASSWORD: !objCreate.confirmPassword ? t('LOGIN.MESSAGE.PASSWORD') : '',
        PREFIX: !objCreate.prefix ? t('VALIDATION.PREFIX_ID') : '',
        FIRST_NAME: !objCreate.firstname ? t('VALIDATION.FIRST_NAME') : '',
        LAST_NAME: !objCreate.lastname ? t('VALIDATION.LAST_NAME') : '',
        FIRST_NAME_EN: !objCreate.firstnameEn ? t('VALIDATION.FIRST_NAME_EN') : '',
        LAST_NAME_EN: !objCreate.lastnameEn ? t('VALIDATION.LAST_NAME_EN') : '',
        POSITION: !objCreate.positionId ? t('VALIDATION.POSITION') : '',
        ROLE: !objCreate.roleId ? t('VALIDATION.ROLE') : '',
        CERTIFICATE: Number(objCreate.positionId) === 2 && !objCreate.certificate ? t('VALIDATION.CERTIFICATE') : ''
      })
    }

    /**
     * a. ความยาวอย่างน้อย 8 หลัก
     * b. ประกอบด้วยตัวอักษร และ ตัวเลข
     * c. ถ้าเป็นอักษรภาษาอังกฤษ ต้องมีอักษรตัวใหญ่และเล็กผสมกัน
     * d. ไม่สามารถใช้รหัสผ่านเป็นภาษาไทยได้
     * e. ต้องไม่มีชื่อผู้ใช้งานเป็นส่วนหนึ่งส่วนใดของรหัสผ่าน
     */
    if (objCreate.password.length < 8) return setErrorMessage({ ...errorMessage, MINIMUM_PASSWORD: t('PERSONNEL.MESSAGE.LIMIT_PACKAGE.MESSAGE_ERROR') })

    const tempMessage = t('PERSONNEL.MESSAGE.LIMIT_PACKAGE.MESSAGE_PASSWORD')
    let message = ''
    /** ความยาวอย่างน้อย 8 หลัก */
    if (objCreate.password.length < 8) message = tempMessage
    /** ประกอบด้วยตัวอักษมีอักษรตัวใหญ่และเล็กผสมกัน และ ตัวเลข */ else if (objCreate.password.toLowerCase() === objCreate.password) message = tempMessage
    else if (objCreate.password.toUpperCase() === objCreate.password) message = tempMessage
    else if (!/\d/.test(objCreate.password)) message = tempMessage
    else if (/[ก-๙]/.test(objCreate.password)) message = tempMessage
    /**  e. ต้องไม่มีชื่อผู้ใช้งานเป็นส่วนหนึ่งส่วนใดของรหัสผ่าน */ else if (objCreate.username && objCreate.password && objCreate.password.search(objCreate.username) !== -1) message = tempMessage

    if (message) return setErrorMessage({ ...errorMessage, PASSWORD: message })

    if (objCreate.password !== objCreate.confirmPassword) return setErrorMessage({ ...errorMessage, PASSWORD_NOT_MATCH: t('PERSONNEL.ALERT.PASSWORDS_DO_NOT_MATCH') })

    if (education.userBackgrounds) {
      let checkNull: any = _.find(education.userBackgrounds, { name: '' })
      if (checkNull) return notiError(t(`PERSONNEL.ALERT.PLEASE_ENTER_QUALIFICATION`))
      checkNull = _.find(education.userBackgrounds, { institute: '' })
      if (checkNull) return notiError(t(`PERSONNEL.ALERT.PLEASE_ENTER_INSTITUTION`))
      checkNull = _.find(education.userBackgrounds, { year: '' })
      if (checkNull) return notiError(t(`PERSONNEL.ALERT.PLEASE_ENTER_GRADUATION_YEAR`))
    }

    if (schedule.userWorkplaces) {
      const checkNullName = _.find(schedule.userWorkplaces, { name: '' })
      const checkNullDayOfWork = _.find(schedule.userWorkplaces, { dayOfWork: '' })
      if (checkNullName) return notiError(t(`PERSONNEL.ALERT.PLEASE_ENTER_WORKPLACE_NAME`))
      else if (checkNullDayOfWork) return notiError(t(`PERSONNEL.ALERT.PLEASE_ENTER_WORK_DATE`))
    }

    if (!checkIsUltraPackage()) {
      return checkUserLimit(
        t('PERSONNEL.MESSAGE.LIMIT_PACKAGE.TITLE'),
        t('PERSONNEL.MESSAGE.LIMIT_PACKAGE.SUBTITLE', {
          package: getPackageKey(),
          number: userLimit(getPackageKey())
        }),
        () => {
          return
        },
        () => {
          crateNewUser(objCreate)
        }
      )
    } else {
      await crateNewUser(objCreate)
    }
  }

  const submitUpdate = async () => {
    const { setup, info, salary, education, schedule, document, profile: oldProfile } = userSetup
    const objUpdate = {
      ...setup,
      ...info,
      ...salary,
      ...education,
      ...schedule,
      ...document,
      profile: (!imageModal && !profileData) ? null : (profile || oldProfile)
    }

    if (objUpdate?.userTags?.length) {
      objUpdate['userTags'] = objUpdate?.userTags?.map((item: any) => { return { tagId: item.tagId } })
    }

    if (!objUpdate.prefix || !objUpdate.firstname || !objUpdate.lastname || !objUpdate.firstnameEn || !objUpdate.lastnameEn || !objUpdate.positionId || !objUpdate.roleId || (Number(objUpdate.positionId) === 2 && !objUpdate.certificate)) {
      let newTab: TABS_FORM_TYPE = tab
      if (!objUpdate.prefix || !objUpdate.firstname || !objUpdate.lastname || !objUpdate.firstnameEn || !objUpdate.lastnameEn) newTab = TABS_FORM_TYPE.INFO
      else if (!objUpdate.positionId || !objUpdate.roleId || (Number(objUpdate.positionId) === 2 && !objUpdate.certificate)) newTab = TABS_FORM_TYPE.SALARY
      setTab(newTab)
      setTabForm(newTab)
      return setErrorMessage({
        ...errorMessage,
        PREFIX: !objUpdate.prefix ? t('VALIDATION.PREFIX_ID') : '',
        FIRST_NAME: !objUpdate.firstname ? t('VALIDATION.FIRST_NAME') : '',
        LAST_NAME: !objUpdate.lastname ? t('VALIDATION.LAST_NAME') : '',
        FIRST_NAME_EN: !objUpdate.firstnameEn ? t('VALIDATION.FIRST_NAME_EN') : '',
        LAST_NAME_EN: !objUpdate.lastnameEn ? t('VALIDATION.LAST_NAME_EN') : '',
        POSITION: !objUpdate.positionId ? t('VALIDATION.POSITION') : '',
        ROLE: !objUpdate.roleId ? t('VALIDATION.ROLE') : '',
        CERTIFICATE: Number(objUpdate.positionId) === 2 && !objUpdate.certificate ? t('VALIDATION.CERTIFICATE') : ''
      })
    }

    if (education.userBackgrounds) {
      let checkNull: any = _.find(education.userBackgrounds, { name: '' })
      if (checkNull) return notiError(t(`PERSONNEL.ALERT.PLEASE_ENTER_QUALIFICATION`))
      checkNull = _.find(education.userBackgrounds, { institute: '' })
      if (checkNull) return notiError(t(`PERSONNEL.ALERT.PLEASE_ENTER_INSTITUTION`))
      checkNull = _.find(education.userBackgrounds, { year: '' })
      if (checkNull) return notiError(t(`PERSONNEL.ALERT.PLEASE_ENTER_GRADUATION_YEAR`))
    }

    if (schedule.userWorkplaces) {
      const checkNullName = _.find(schedule.userWorkplaces, { name: '' })
      const checkNullDayOfWork = _.find(schedule.userWorkplaces, { dayOfWork: '' })
      if (checkNullName) return notiError(t(`PERSONNEL.ALERT.PLEASE_ENTER_WORKPLACE_NAME`))
      else if (checkNullDayOfWork) return notiError(t(`PERSONNEL.ALERT.PLEASE_ENTER_WORK_DATE`))
    }

    if (user?.userId === userId && objUpdate.status === 'INACTIVE') {
      return swalWarning(
        `<p class="mb-0 mx-auto" style="max-width: 325px">${t('USER.ALERT.WARNING_MY_USER')}</p>`,
        `<p class="mb-0 mx-auto" style="max-width: 325px">${t('USER.ALERT.WARNING_MY_USER_', { user: `${objUpdate.firstname} ${objUpdate.lastname}` })}</p>`,
        () => {
          setStatus('ACTIVE')
          dispatch(editUser({ value: 'ACTIVE', key: 'status' }))
        }
      )
    }

    if (!checkIsUltraPackage() && oldStatus !== status && objUpdate.status === 'ACTIVE') {
      return checkUserLimit(
        t('PERSONNEL.MESSAGE.LIMIT_PACKAGE.TITLE'),
        t('PERSONNEL.MESSAGE.LIMIT_PACKAGE.SUBTITLE', {
          package: getPackageKey(),
          number: userLimit(getPackageKey())
        }),
        () => {
          return
        },
        () => {
          updateUser(objUpdate)
        }
      )
    } else await updateUser(objUpdate)
  }


  const crateNewUser = async (objCreate: any) => {
    setLoading(true)
    await PersonnelApi.create(objCreate)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          history.push(routeName.personnels)
          notiSuccess(t(`PERSONNEL.ALERT.CREATE_SUCCEED`), '', null, () => {
            return
          })
        } else {
          const err = res.response.data
          if (err?.message?.includes('userWorkplaces')) {
            return notiError(t(`PERSONNEL.ALERT.USERWORKPLACES_ISDUPLICATE`))
          }
          notiError(t(`${err.message}`))
        }
      })
      .catch((e) => {
        const err = e.response.data
        if (err?.message?.includes('userWorkplaces')) {
          return notiError(t(`PERSONNEL.ALERT.USERWORKPLACES_ISDUPLICATE`))
        }
        notiError(t(`${err.message}`))
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const updateUser = async (objUpdate: any) => {
    setLoading(true)
    await PersonnelApi.update(userId, objUpdate)
      .then(async (res: any) => {
        if (user?.userId === userId) await reloadMyUser()
        notiSuccess(t(`USER.MESSAGE.SUCCESS.UPDATE`), '', null, () => {
          return
        })
        history.push(routeName.personnels)
      })
      .catch((e) => {
        const err = e.response.data
        if (err?.message?.includes('userWorkplaces')) {
          return notiError(t(`PERSONNEL.ALERT.USERWORKPLACES_ISDUPLICATE`))
        }
        notiError(t(`${err.message}`))
      })
      .finally(() => setLoading(false))
  }

  const reloadMyUser = async () => {
    setLoading(true)
    const { data } = await PersonnelApi.findProfile().finally(() => setLoading(false))
    if (data) {
      dispatch(editMe({ value: data, key: 'me' }))
    }
  }

  const handleTabChange = (event: React.SyntheticEvent, newValue: TABS_FORM_TYPE) => {
    setTab(newValue)
  }

  const uploadProfile = (files: any) => {
    if (files[0]) {
      const file = files[0]
      const fileName = file.name.split('.')
      const detailImage = {
        fileId: null,
        base64: '',
        fileExtension: fileName[fileName.length - 1],
        fileSize: file.size.toString()
      }
      const reader: any = new FileReader()
      reader.addEventListener('load', () => {
        const base64 = reader.result.split(',')
        setImageModal(reader.result)
        // setProfileData(reader.result)
        detailImage.base64 = base64.length > 0 ? base64[base64.length - 1] : reader.result
      })
      reader.readAsDataURL(file)
      setProfile(detailImage)
    }
  }

  const handleCancelPic = () => {
    setIsOpenPic(false)
    setImageModal(null)
    setIsOpenWebCam(false)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const handleSubmitPic = () => {
    setProfileData(imageModal)
    setIsOpenPic(false)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  useEffect(() => {
    if (!isOpenPic) {
      setImageModal(null)
      setIsOpenWebCam(false)
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
    }
  }, [isOpenPic])

  // useEffect(() => {
  //   if (isOpenPic) {
  //     if (profile?.fileName && profile.filePath) {
  //       const url = `${fileUrl}/${profile.filePath}/${profile.fileName}`;
  //       setImageModal(url);
  //     } else {
  //       setImageModal(null);
  //     }
  //     setIsOpenWebCam(false);
  //   } else {
  //     setImageModal(null)
  //     setIsOpenWebCam(false)
  //     if (fileInputRef.current) {
  //       fileInputRef.current.value = ''
  //     }
  //   }
  // }, [isOpenPic, profile]);

  const onResetAuth = () => {
    dispatch(resetModal())
    setPassword(templatePassword)
    setPasswordErrorMessage(initStatePasswordErrorMessage)
  }

  const onSubmitAuth = async () => {
    if (!password.newPassword || !password.confirmPassword) {
      return setPasswordErrorMessage({ ...passwordErrorMessage, NEW_PASSWORD: !password.newPassword ? t('LOGIN.MESSAGE.PASSWORD') : '', CONFIRM_PASSWORD: !password.confirmPassword ? t('LOGIN.MESSAGE.PASSWORD') : '' })
    }

    /**
     * a. ความยาวอย่างน้อย 8 หลัก
     * b. ประกอบด้วยตัวอักษร และ ตัวเลข
     * c. ถ้าเป็นอักษรภาษาอังกฤษ ต้องมีอักษรตัวใหญ่และเล็กผสมกัน
     * d. ไม่สามารถใช้รหัสผ่านเป็นภาษาไทยได้
     * e. ต้องไม่มีชื่อผู้ใช้งานเป็นส่วนหนึ่งส่วนใดของรหัสผ่าน
     */

    const tempMessage = t('PERSONNEL.MESSAGE.LIMIT_PACKAGE.MESSAGE_PASSWORD')
    let message = ''
    /** ความยาวอย่างน้อย 8 หลัก */
    if (password.newPassword.length < 8) message = tempMessage
    /** ประกอบด้วยตัวอักษมีอักษรตัวใหญ่และเล็กผสมกัน และ ตัวเลข */ else if (password.newPassword.toLowerCase() === password.newPassword) message = tempMessage
    else if (password.newPassword.toUpperCase() === password.newPassword) message = tempMessage
    else if (!/\d/.test(password.newPassword)) message = tempMessage
    else if (/[ก-๙]/.test(password.newPassword)) message = tempMessage
    /**  e. ต้องไม่มีชื่อผู้ใช้งานเป็นส่วนหนึ่งส่วนใดของรหัสผ่าน */ else if (personnel.username && password.newPassword && password.newPassword.search(personnel.username) !== -1) message = tempMessage
    if (message) return setPasswordErrorMessage({ ...passwordErrorMessage, NEW_PASSWORD: message })

    if (password.newPassword !== password.confirmPassword) {
      return setPasswordErrorMessage({ ...passwordErrorMessage, PASSWORD_NOT_MATCH: t('PERSONNEL.ALERT.PASSWORDS_DO_NOT_MATCH') })
    }

    const payload: ChangePassword = {
      password: password.newPassword,
      confirmPassword: password.confirmPassword
    }

    await PersonnelApi.changePassword(userId, payload)
      .then(() => {
        dispatch(resetModal())
        setPassword(templatePassword)
        setInputModal('')
        setErrorMessageModal('')
        notiSuccess(t('PERSONNEL.ALERT.PASSWORD_CHANGE_SUCCESSFUL'))
      })
      .catch(() => {
        return
      })
  }

  const clearReadOnly = () => {
    setReadOnly(false)
  }

  const handleOpenEditAuth = (status: 'username' | 'password') => {
    setStatusEdit(status)
    setIsOpen(true)
  }

  const handleReLoadData = async () => {
    await PersonnelApi.findById(userId).then((res) => {
      history.push(routeName.personnels + '/update', res?.data)
    })
  }

  const handleErrorPassword = () => {
    const tempMessage = t('PERSONNEL.MESSAGE.LIMIT_PACKAGE.MESSAGE_PASSWORD')

    if (inputModal.length < 8) return tempMessage
    else if (inputModal.toLowerCase() === inputModal) return tempMessage
    else if (inputModal.toUpperCase() === inputModal) return tempMessage
    else if (!/\d/.test(inputModal)) return tempMessage
    else if (/[ก-๙]/.test(inputModal)) return tempMessage
    else if (user?.setup?.username && inputModal && inputModal.search(user?.setup?.username) !== -1) return tempMessage
  }

  const onSubmit = async () => {
    if (!inputModal || inputModal === '') {
      return setErrorMessageModal(t(`PERSONNEL.MODAL.EMPTY_${statusEdit.toUpperCase()}`))
    }
    if (statusEdit === 'password') {
      onSubmitPassword()
    } else {
      onSubmitUsername()
    }
  }

  const onSubmitPassword = async () => {
    const message: any = handleErrorPassword()
    if (message) return setErrorMessageModal(message)
    const payload: ChangePassword = {
      password: inputModal,
      confirmPassword: inputModal
    }
    await PersonnelApi.changePassword(userId, payload)
      .then(() => {
        setIsOpen(false)
        notiSuccess(t('PERSONNEL.ALERT.PASSWORD_CHANGE_SUCCESSFUL'))
        setInputModal('');
        setErrorMessageModal('');
        handleReLoadData()
      })
      .catch(() => {
        return
      })
  }

  const onSubmitUsername = async () => {
    await PersonnelApi.changeUsername(userId, inputModal)
      .then(() => {
        setIsOpen(false)
        setInputModal('');
        setErrorMessageModal('');
        notiSuccess(t('PERSONNEL.ALERT.USERNAME_CHANGE_SUCCESSFUL'))
        handleReLoadData()
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.message
        if (errorMessage) {
          notiError(t(`PERSONNEL.ALERT.${errorMessage}`))
        } else {
          notiError(t('PERSONNEL.ALERT.ERROR'))
        }
        return
      })
  }

  const capture = useCallback(() => {
    const imageSrc: any = webcamRef.current?.getScreenshot()
    setImageModal(imageSrc)
    setIsOpenWebCam(false)
  }, [webcamRef])

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files) return;
    Array.from(files).forEach(file => {
      const isImage = ['image/png', 'image/jpeg'].includes(file.type);
      const isUnderLimit = file.size <= MAX_FILE_SIZE;
      if (!isImage || !isUnderLimit) {
        notiError(t('REGISTER.SIGNATURE.SUPPORT_SIGN'))
      } else {
        uploadProfile([file]);
      }
    });
  };

  useEffect(() => {
    if (isOpenPic) {
      setImageModal(profileData ?? null);
      setIsOpenWebCam(false);
    }
  }, [isOpenPic, profileData]);


  return (
    <Box sx={{ background: '#ffffff 0% 0% no-repeat padding-box !important', boxShadow: '0px 3px 6px #0000001a !important', border: '1px solid #e5e5e5 !important', height: '100%', backgroundColor: colors.white }}>
      <Box className="d-flex flex-column h-100">
        <HeaderLabel
          text={userId ? t('USER.TITLE_UPDATE') : t('USER.TITLE_CREATE')}
          navigator={{ previousTo: routeName.personnels, previousTitle: t('USER.TITLE'), currentTitle: userId ? t('USER.TITLE_UPDATE') : t('USER.TITLE_CREATE') }}
          goBack={routeName.personnels}
          disabledSend={loading}
          onSubmit={userId ? submitUpdate : submit}
        // isEditPersonnel={isEdit}
        // onEditPersonnel={() => dispatch(showModal())}
        />
        <Box sx={{ background: '#ffffff 0% 0% no-repeat padding-box', boxShadow: '0px 3px 6px #0000001a', border: '1px solid #e5e5e5', mx: '24px', mb: '24px', height: '100%', overflow: 'hidden', borderRadius: '8px' }}>
          <Box sx={{ height: '100vh', overflow: 'hidden', p: '16px' }}>
            <Grid container spacing={2} className="m-0 h-100 w-100 flex-column flex-xl-row">
              <Grid lg={2} className={`w-100 px-3`} sx={{ borderRight: { lg: `1px solid ${colors.lightGray}` } }}>
                <Box className="py-2">
                  <Box className="align-content-center flex-center pt-3">
                    <UseStyled.CardProfileImg className={`card-profile personal-avatar mt-2 mt-md-0 `} onClick={() => setIsOpenPic(true)}>
                      <Box className={`personal-figure `}>
                        {profileData ? <img src={profileData} alt="profile" onError={onImgError} /> : <img src={imgs.defaultAvatar} onError={onImgError} alt="default profile" />}
                        <IconButton className={`btn-add-profile`} aria-label="upload picture">
                          <PhotoCamera />
                        </IconButton>
                      </Box>
                    </UseStyled.CardProfileImg>
                  </Box>
                  {isEdit && (
                    <Box className={'mt-3'} sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                      <Box>
                        <Box sx={{ fontSize: '14px', fontWeight: '400', color: '#5A5A5A' }}>{`${t('PERSONNEL.MODAL.EMPLOYEE_ID')}: ${userSetup?.setup?.userCode || '-'}`}</Box>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Box sx={{ fontSize: '14px', fontWeight: '400', color: '#5A5A5A' }}>{`${t('PERSONNEL.MODAL.USERNAME')}: ${userSetup?.setup?.username || '-'}`}</Box>
                        <Box>
                          <MainButton
                            style={{
                              padding: '2px 10px !important',
                              '.MuiButton-startIcon': {
                                marginRight: '0px !important'
                              },
                              height: '30px',
                              width: '70px'
                            }}
                            type="primary"
                            variant={'outlined'}
                            title={t(`PERSONNEL.BUTTON.EDIT`)}
                            startIcon={<BtnEditOutlined />}
                            onClick={() => handleOpenEditAuth('username')}
                          />
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Box sx={{ fontSize: '14px', fontWeight: '400', color: '#5A5A5A' }}>{`${t('รหัสผ่าน')}: ${'******'}`}</Box>
                        <Box>
                          <MainButton
                            style={{
                              padding: '2px 10px !important',
                              '.MuiButton-startIcon': {
                                marginRight: '0px !important'
                              },
                              height: '30px',
                              width: '70px'
                            }}
                            type="primary"
                            variant={'outlined'}
                            title={t(`PERSONNEL.BUTTON.EDIT`)}
                            startIcon={<BtnEditOutlined />}
                            onClick={() => handleOpenEditAuth('password')}
                          />
                        </Box>
                      </Box>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
                        <SwitchButton
                          onChange={() => {
                            const changeStatus = status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
                            setStatus(changeStatus)
                            dispatch(editUser({ value: changeStatus, key: 'status' }))
                          }}
                          checked={status === 'ACTIVE'} />
                      </Box>
                      <Divider className="mx-0 mt-3 d-xl-none" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid lg={10} className={'px-0 w-100 h-100 overflow-hidden'} sx={{ flex: 1 }}>
                <Box className="d-flex flex-column overflow-hidden h-100 pb-2 pr-3" sx={{ width: '100%', typography: 'body1' }}>
                  <TabContext value={tab}>
                    <Box sx={{ borderBottom: 1, borderColor: colors.extraLightBlue }}>
                      <TabList className="pl-3" onChange={handleTabChange} aria-label="personel tabs" variant="scrollable" TabIndicatorProps={{ style: { backgroundColor: colors.transparent, color: colors.themeSecondColor } }}>
                        <UseStyled.CustomTab
                          tabForm={tabForm}
                          selectLabel={TABS_FORM_TYPE.SETUP}
                          label={`${t('USER.HEAD_TITLE.ACCOUNT_SETTING')}*`}
                          value={TABS_FORM_TYPE.SETUP}
                          onClick={(e) => setTabForm(TABS_FORM_TYPE.SETUP)}
                          className={`py-3 px-4 ${errorMessage.USER_CODE || errorMessage.USER_NAME || errorMessage.PASSWORD || errorMessage.CONFIRM_PASSWORD || errorMessage.MINIMUM_PASSWORD || errorMessage.PASSWORD_NOT_MATCH ? 'error' : ''}`}
                        />
                        <UseStyled.CustomTab
                          tabForm={tabForm}
                          selectLabel={TABS_FORM_TYPE.INFO}
                          label={`${t('USER.HEAD_TITLE.PROFILE')}*`}
                          value={TABS_FORM_TYPE.INFO}
                          onClick={(e) => setTabForm(TABS_FORM_TYPE.INFO)}
                          className={`py-3 px-4 ${errorMessage.PREFIX || errorMessage.FIRST_NAME || errorMessage.LAST_NAME ? 'error' : ''}`}
                        />
                        <UseStyled.CustomTab
                          tabForm={tabForm}
                          selectLabel={TABS_FORM_TYPE.SALARY}
                          label={`${t('USER.HEAD_TITLE.ROLE')}*`}
                          value={TABS_FORM_TYPE.SALARY}
                          onClick={(e) => setTabForm(TABS_FORM_TYPE.SALARY)}
                          className={`py-3 px-4 ${errorMessage.POSITION || errorMessage.CERTIFICATE || errorMessage.ROLE ? 'error' : ''}`}
                        />
                        <UseStyled.CustomTab
                          tabForm={tabForm}
                          selectLabel={TABS_FORM_TYPE.EDUCATION}
                          label={t('USER.HEAD_TITLE.EDUCATION')}
                          value={TABS_FORM_TYPE.EDUCATION}
                          onClick={(e) => setTabForm(TABS_FORM_TYPE.EDUCATION)}
                          className={'py-3 px-4'}
                        />
                        <UseStyled.CustomTab
                          tabForm={tabForm}
                          selectLabel={TABS_FORM_TYPE.SCHEDULE}
                          label={t('USER.HEAD_TITLE.WORK_SCHEDULE')}
                          value={TABS_FORM_TYPE.SCHEDULE}
                          onClick={(e) => setTabForm(TABS_FORM_TYPE.SCHEDULE)}
                          className={'py-3 px-4'}
                        />
                        <UseStyled.CustomTab tabForm={tabForm} selectLabel={TABS_FORM_TYPE.DOCUMENT} label={t('USER.HEAD_TITLE.DOCUMENT')} value={TABS_FORM_TYPE.DOCUMENT} onClick={(e) => setTabForm(TABS_FORM_TYPE.DOCUMENT)} className={'py-3 px-4'} />
                      </TabList>
                    </Box>

                    <Box style={{ display: tabForm === 'SETUP' ? 'block' : 'none', overflowY: 'auto', marginBottom: '200px', height: '90%' }}>
                      <SetupAccount
                        isEdit={isEdit}
                        errorMessage={errorMessage}
                        resetErrorMessage={() => {
                          setErrorMessage({ ...errorMessage, USER_CODE: '', USER_NAME: '', PASSWORD: '', CONFIRM_PASSWORD: '', PASSWORD_NOT_MATCH: '', MINIMUM_PASSWORD: '' })
                        }}
                      />
                    </Box>
                    <Box style={{ display: tabForm === 'INFO' ? 'block' : 'none', overflowY: 'auto', marginBottom: '200px', height: '90%' }}>
                      <Information
                        isEdit={isEdit}
                        errorMessage={errorMessage}
                        resetErrorMessage={() => {
                          setErrorMessage({ ...errorMessage, PREFIX: '', FIRST_NAME: '', LAST_NAME: '', FIRST_NAME_EN: '', LAST_NAME_EN: '' })
                        }}
                      />
                    </Box>
                    <Box style={{ display: tabForm === 'SALARY' ? 'block' : 'none', overflowY: 'auto', marginBottom: '200px', height: '90%' }}>
                      <SalarynPosition
                        isEdit={isEdit}
                        errorMessage={errorMessage}
                        user={location.state}
                        resetErrorMessage={() => {
                          setErrorMessage({ ...errorMessage, POSITION: '', CERTIFICATE: '', ROLE: '' })
                        }}
                      />
                    </Box>
                    <Box style={{ display: tabForm === 'EDUCATION' ? 'block' : 'none', overflowY: 'auto', marginBottom: '200px', height: '90%' }}>
                      <Education isEdit={isEdit} />
                    </Box>
                    <Box style={{ display: tabForm === 'SCHEDULE' ? 'block' : 'none', overflowY: 'auto', marginBottom: '200px', height: '90%' }}>
                      <Schedule isEdit={isEdit} />
                    </Box>
                    <Box
                      style={{ display: tabForm === 'DOCUMENT' ? 'block' : 'none', overflowY: 'auto', marginBottom: '200px', height: '90%' }}
                      onClick={() => {
                        const canvasCollection = document.getElementsByTagName('canvas')
                        Array.from(canvasCollection).forEach(function (element) {
                          element.style.removeProperty('width')
                          element.style.removeProperty('height')
                        })
                      }}
                    >
                      <Document isEdit={isEdit} attachment={attachments} />
                    </Box>
                  </TabContext>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>


      <Loading show={loading} />
      <PageModal
        title=''
        size='S'
        isOpen={isOpenPic}
        handleClose={handleCancelPic}
        onCancel={{ onClick: handleCancelPic, title: t('PERSONNEL.MODAL.CANCEL') }}
        onSubmit={{ onClick: handleSubmitPic, title: t('PERSONNEL.MODAL.SUBMIT') }}
      >
        <Box>
          <Box display="flex" justifyContent="center" alignItems="center" marginTop="32px" flexDirection="column">
            {isOpenWebCam ?
              <Box gap="16px" display="flex" flexDirection="column" alignItems="center">
                <Webcam ref={webcamRef} width={300} height={300} screenshotFormat="image/jpeg" />
                <MainButton onClick={() => capture()} title='ถ่ายรูปภาพ' type='primary' variant='contained' />
              </Box>
              :
              <>
                {imageModal ?
                  <Box position="relative" borderRadius="100%" width="300px" height="300px">
                    <img src={imageModal} alt="" style={{ width: '300px', height: '300px', borderRadius: '50%' }} />
                    <Box position="absolute" right={50} top={0} width={36} height={36} bgcolor="#C5C5C5" borderRadius="100%" display="flex" justifyContent="center" alignItems="center" sx={{ cursor: 'pointer' }} onClick={() => {
                      setImageModal(null)
                      // setProfileData(null)
                    }}>
                      <CloseIcon style={{ color: 'white' }} />
                    </Box>
                  </Box>
                  :
                  <Box borderRadius="100%" width="300px" height="300px" display="flex" justifyContent="center" alignItems="center" bgcolor="#A8A8A8">
                    <PersonIcon style={{ color: 'white' }} sx={{ width: "200px", height: '200px' }} />
                  </Box>
                }
              </>
            }

            <Box display="flex" flexDirection="row" gap="16px" marginTop="16px">
              <input
                type="file"
                accept="image/png, image/jpeg"
                hidden
                {...getInputProps({ onChange: undefined })}
                onChange={handleFileChange}
              />
              <Box {...getRootProps({ isDragActive, isDragAccept, isDragReject })}>
                <MainButton onClick={() => setIsOpenWebCam(false)} title='เลือกรูปจากไฟล์' type='primary' variant='outlined' />
              </Box>
              <MainButton onClick={() => setIsOpenWebCam(true)} title='ถ่ายรูป' type='primary' variant='outlined' style={{ width: '120px' }} />
            </Box>
            <Typography fontSize="16px" fontWeight={400} marginY="16px">รองรับไฟล์ PNG,JPG ขนาดไม่เกิน 2 MB.</Typography>
          </Box>
        </Box>
      </PageModal>

      <PageModal
        title={t(`PERSONNEL.MODAL.EDIT_${statusEdit.toUpperCase()}`)}
        size='XS'
        isOpen={isOpen}
        handleClose={() => {
          setIsOpen(false)
          setErrorMessageModal('')
          setInputModal('')
        }}
        onCancel={{
          onClick: () => {
            setIsOpen(false)
            setErrorMessageModal('')
            setInputModal('')
          }, title: t('PERSONNEL.MODAL.CANCEL')
        }}
        onSubmit={{ onClick: onSubmit, title: t('PERSONNEL.MODAL.SUBMIT') }}
      >
        <Box display="flex" flexDirection="column" gap="16px">
          <Grid container>
            <Grid item xs={3}>
              <Typography>{t('PERSONNEL.MODAL.EMPLOYEE_ID')}:</Typography>
            </Grid>
            <Grid item xs={9}>
              <Typography>{userSetup?.setup?.userCode || '-'}</Typography>
            </Grid>
            <Grid item xs={3} marginTop="16px">
              <Typography>{t('PERSONNEL.MODAL.USERNAME')}: </Typography>
            </Grid>
            <Grid item xs={9} marginTop="16px">
              <Typography>{userSetup?.setup?.username || '-'}</Typography>
            </Grid>
          </Grid>

          <TextInput
            label={t(`PERSONNEL.MODAL.NEW_${statusEdit.toUpperCase()}`)}
            fullWidth
            value={inputModal}
            onChange={(e) => {
              setInputModal(e.target.value);
              if (errMessageModal) setErrorMessageModal('');
            }}
            marginBottomErrorText='40px'
            helperText={errMessageModal}
          />
        </Box>
      </PageModal>
    </Box>
  )
}
